import MuxPlayer from '@mux/mux-player-react'
import '@mux/mux-player/themes/minimal'
import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'

interface IgniteVideoPlayerProps {
	playbackId: string
	poster?: string
	autoPlay?: boolean | 'muted'
	loop?: boolean
	muted?: boolean
	streamType?: 'on-demand' | 'live' | 'll-live' | 'live:dvr' | 'll-live:dvr'
	className?: string
	style?: React.CSSProperties
	/** Optional aspect ratio CSS value e.g. "16/9" */
	aspectRatio?: string
}

/**
 * Ignite-branded video player wrapper around MuxPlayer.
 *
 * - Uses the Mux "minimal" theme (clean layout).
 * - Only play/pause and mute controls are visible — everything else
 *   (seek bar, time display, fullscreen, captions, settings, AirPlay,
 *   Cast, PiP, playback rate) is hidden via CSS variables.
 * - Brand colors: accent (#eb008b Ignite pink) on the play icon and
 *   active state.
 */
export function IgniteVideoPlayer({
	playbackId,
	poster,
	autoPlay,
	loop,
	muted,
	streamType = 'on-demand',
	className,
	style,
	aspectRatio,
}: IgniteVideoPlayerProps) {
	return (
		<MuxPlayer
			playbackId={playbackId}
			poster={poster}
			autoPlay={autoPlay}
			loop={loop}
			muted={muted}
			streamType={streamType}
			theme="minimal"
			accentColor="#eb008b"
			primaryColor="#ffffff"
			secondaryColor="rgba(35, 31, 32, 0.6)"
			className={cn('h-full w-full', className)}
			style={{
				'--seek-backward-button': 'none',
				'--seek-forward-button': 'none',
				'--captions-button': 'none',
				'--airplay-button': 'none',
				'--pip-button': 'none',
				'--fullscreen-button': 'none',
				'--cast-button': 'none',
				'--playback-rate-button': 'none',
				'--rendition-selectmenu': 'none',
				'--audio-track-selectmenu': 'none',
				'--time-range': 'none',
				'--volume-range': 'none',
				'--time-display': 'none',
				'--duration-display': 'none',
				'--title-display': 'none',
				'--live-button': 'none',
				...(aspectRatio ? { aspectRatio } : {}),
				...(style as Record<string, string | undefined>),
			}}
		/>
	)
}
